(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('selectShipper', function (Forwarder) {
            return {
                require: '^ngModel',
                scope: {
                    type: "=",
                    modelValue: '=ngModel',
                    options: '='
                },
                templateUrl: 'app/entities/forwarder/select-shipper/select-shipper.html',
                link: function(scope, $element, $attrs, ngModelCtrl) {

                    var defaultOptions = {
                        // activityFiltering: true
                    };

                    scope.requestOptions = angular.extend({}, defaultOptions, scope.options);
                    var queryPromise = Forwarder.autocomplete(scope.requestOptions).$promise;
                    queryPromise
                        .then(function (items) {
                            scope.shippers = items;
                        })
                        .catch(function (reason) {
                            scope.shippers = [];
                        });

                    scope.setValue = function(value){
                        ngModelCtrl.$setViewValue(value);
                    };

                }
            };
        });

})();
